import { useLocation } from "react-router-dom"
import Logo from "../../../components/logo/LogoCompressed.png"
import { F_START_AGB, F_START_DATENSCHUTZ, F_START_IMPRESSUM, F_START_MINORINFO } from "../../../constants/routes"
import bmbf from "../assets/bmbf.png"
import { getHref, navLinks } from "../data/navLinks"

const bookaySectionLinks = navLinks.map((n) => ({
  text: n.label,
  link: n.href,
}))

const legalSectionLinks = [
  {
    text: "AGB",
    link: F_START_AGB,
  },
  {
    text: "Hinweis für minderjährige Nutzer",
    link: F_START_MINORINFO,
  },
  {
    text: "Datenschutzerklärung",
    link: F_START_DATENSCHUTZ,
  },
  {
    text: "Impressum",
    link: F_START_IMPRESSUM,
  },
  {
    text: "Cookies",
    link: "",
    onClick: () => localStorage.removeItem("cookieConsent"),
  },
]

export function Footer() {
  const location = useLocation()

  return (
    <footer className="border-t bg-white">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-8 px-4 py-12 sm:px-6 md:grid-cols-4 lg:px-8">
        <div className="col-span-2 md:col-span-1">
          <img src={Logo} width={180} alt="Bookay Logo" />
          <p className="mt-3 text-sm text-gray-600">
            Ein Projekt aus Berlin, entwickelt von Schülern für Schulen, um Schulbücher im Umlauf zu halten statt sie ungenutzt zu lassen.
          </p>
        </div>
        {[
          {
            title: "Bookay",
            links: bookaySectionLinks,
          },
          {
            title: "Rechtliches",
            links: legalSectionLinks,
          },
        ].map((col) => (
          <div key={col.title}>
            <h4 className="text-sm font-semibold">{col.title}</h4>
            <ul className="mt-3 space-y-2 text-sm text-gray-600">
              {col.links.map((l) => (
                <li key={l} onClick={l?.onClick}>
                  <a href={getHref(l.link, location)} className="hover:text-black/70">
                    {l.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div>
          <img src={bmbf} alt="BMBF Logo" className="max-h-24 w-auto object-contain" />
        </div>
      </div>
      <div className="border-t">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-6 text-xs text-gray-500 sm:px-6 lg:px-8">
          <p>© {new Date().getFullYear()} Dmitrij Tjumenzew</p>
          {/* <div className="flex items-center gap-4">
            <a href="#" className="hover:text-black/70">
              Privacy
            </a>
            <a href="#" className="hover:text-black/70">
              Terms
            </a>
            <a href="#" className="hover:text-black/70">
              Cookies
            </a>
          </div> */}
        </div>
      </div>
    </footer>
  )
}
